import {Container, FormControl, InputLabel, Select, TextField} from '@material-ui/core';

export default function InputForm(prop: any) {
    let classes: any = {
        margin: {
            marginRight: '2.5rem',
        },
    };
    function genderChanged(e: any) {
        prop.state.gender = e.target.value;
        prop.stateChanger(prop.state);
    }
    function ageChange(e: any) {
        prop.state.age = e.target.value;
        errorAge();
        prop.stateChanger(prop.state);
    }
    function tobaccoOptionChanged(e: any) {
        prop.state.tobacco = e.target.value;
        prop.stateChanger(prop.state);
    }
    function amountChanged(e: any) {
        prop.state.amount = e.target.value;
        amountError();
        prop.stateChanger(prop.state);
    }
    function errorAge() {
        prop.state.ageError = !(Number(prop.state.age) > 1 && Number(prop.state.age < 69));
        prop.state.overallError = prop.state.amountError || prop.state.ageError;
    }
    function amountError() {
        prop.state.amountError = !(
            Number(prop.state.amount) >= 200 &&
            Number(prop.state.amount) <= 2000 &&
            Number(prop.state.amount) % 100 === 0
        );
        prop.state.overallError = prop.state.amountError || prop.state.ageError;
    }
    const tobaccoOption = ['Non Tobacco', 'Preferred Non Tobacco', 'Preferred Tobacco', 'Tobacco'];
    return (
        <div>
            <Container>
                <TextField
                    value={prop.state.age}
                    style={classes.margin}
                    id="age"
                    label="Age"
                    variant="outlined"
                    onChange={ageChange}
                    error={prop.state.ageError}
                    helperText={prop.state.ageError ? 'Invalid Age' : ''}
                />

                <FormControl style={classes.margin} variant="outlined">
                    <InputLabel htmlFor="outlined-age-native-simple">Gender</InputLabel>
                    <Select
                        native
                        value={prop.state.gender}
                        onChange={genderChanged}
                        label="Gender"
                        inputProps={{
                            name: 'gender',
                            id: 'outlined-age-native-simple',
                            key: 1,
                        }}
                    >
                        <option value={'Male'} key={1}>
                            Male
                        </option>
                        <option value={'Female'} key={2}>
                            Female
                        </option>
                    </Select>
                </FormControl>

                <FormControl style={classes.margin} variant="outlined">
                    <InputLabel htmlFor="outlined-age-native-simple">Tobaaco Options</InputLabel>
                    <Select
                        native
                        value={prop.state.tobacco}
                        onChange={tobaccoOptionChanged}
                        label="Tobaaco Options"
                        disabled={prop.state.age === 0 ? true : false}
                        inputProps={{
                            name: 't-opt',
                            id: 'outlined-age-native-simple',
                            key: 2,
                        }}
                    >
                        {tobaccoOption.map((item: string, index: number) => {
                            if ((Number(prop.state.age) < 18 && item == 'Non Tobacco') || prop.state.age > 17)
                                return (
                                    <option value={item} key={index + 5}>
                                        {item}
                                    </option>
                                );
                        })}
                    </Select>
                </FormControl>

                <TextField
                    style={classes.margin}
                    id="amount"
                    label="Amount"
                    variant="outlined"
                    value={prop.state.amount}
                    onChange={amountChanged}
                    error={prop.state.amountError}
                    helperText={prop.state.amountError ? 'Invalid Amount' : ''}
                />
            </Container>
        </div>
    );
}
